module.exports = __webpack_public_path__ + "img/cn.b8090fda.png";